<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' :subPath="title"></bread-crumb>
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="100px" class="form_body">
      <el-form-item label="标题" prop="title" style="width: 400px;">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="title_sub" style="width: 400px;">
        <el-input v-model="formData.title_sub" type="textarea" :rows="1"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="请选择分类" filterable>
          <el-option label="请选择分类" :value="0"></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="特色栏目" prop="character_id">
        <el-select v-model="formData.character_id" placeholder="请选择特色栏目" filterable>
          <el-option label="请选择特色栏目" :value="0"></el-option>
          <el-option v-for="item in characterList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作者分类" prop="author_type">
        <el-select v-model="formData.author_type" placeholder="请选择作者分类" filterable @change="authorTypeChange">
          <el-option v-for="item in authorTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="authorTypeTitle" prop="author">
        <el-select v-model="formData.author" :placeholder="'请选择'+authorTypeTitle" filterable allow-create>
          <el-option :label="'请选择'+authorTypeTitle" :value="0"></el-option>
          <el-option v-for="item in authorList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/upload_img222"
            name="img"
            :before-upload="handleUpload"
            :show-file-list="false"
            :on-success="handlePicSuccess">
            <img v-if="picUrl" :src="picUrl+'?imageView2/0/w/50'" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="图片标注" prop="pic_label" style="width: 400px;">
        <el-input v-model="formData.pic_label" placeholder="请输入图片标注"></el-input>
      </el-form-item>
      <el-form-item label="发布时间" prop="publish_start">
        <el-date-picker
          v-model="formData.publish_start"
          type="datetime"
          value-format="timestamp"
          placeholder="发布时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="媒体内容">
        <el-select v-model="formData.audio_id" placeholder="输入关键字搜索音频" filterable remote :remote-method="getAudioSelectList" clearable @change="handleMediaSelect($event, 1)" :loading="mediaLoading[1]" style="width: 400px; margin-right: 16px;">
          <el-option v-for="item in mediaOptions[1]" :key="item.id" :label="formatMediaLabel(item)" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="formData.video_id" placeholder="输入关键字搜索视频" filterable remote :remote-method="getVideoSelectList" clearable @change="handleMediaSelect($event, 2)" :loading="mediaLoading[2]" style="width: 400px;">
          <el-option v-for="item in mediaOptions[2]" :key="item.id" :label="formatMediaLabel(item)" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="body" style="width: 98%;">
        <my-ueditor ref="bodyEditor" :value="formData.body" @getContent="getBody" style="line-height: 10px;"></my-ueditor>
      </el-form-item>
      <div class="translation_panel">
        <div class="translation_panel_header" @click="translationVisible = !translationVisible">
          <span>英文翻译</span>
          <i :class="translationVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div v-if="translationVisible" class="translation_panel_body">
          <el-form-item label="文章链接">
            <el-input v-model.trim="articleApiUrl" placeholder="请输入文章页面或详情 API 地址" class="article-api-input">
              <el-button slot="append" type="primary" icon="el-icon-download" :loading="articleFetchLoading" @click="fetchArticleContent">抓取标题、内容和作者</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="翻译操作">
            <el-button type="warning" icon="el-icon-s-promotion" :loading="titleTranslateLoading" @click="translateTitle">翻译标题</el-button>
            <el-button type="warning" icon="el-icon-document" :loading="bodyTranslateLoading" @click="translateBody">翻译内容</el-button>
          </el-form-item>
          <el-form-item label="英文标题" prop="title_en" style="width: 400px;">
            <el-input v-model="formData.title_en"></el-input>
          </el-form-item>
          <el-form-item label="英文作者" prop="author_en" style="width: 400px;">
            <el-input v-model="formData.author_en"></el-input>
          </el-form-item>
          <el-form-item label="英文内容" prop="body_en" style="width: 98%;">
            <my-ueditor ref="bodyEnEditor" :value="formData.body_en" @getContent="getBodyEn" style="line-height: 10px;"></my-ueditor>
          </el-form-item>
        </div>
      </div>
      <div style="text-align: center;">
        <el-button @click="closeContentPage" style="margin-right: 20px;">取 消</el-button>
        <el-button @click="submitContent(2)">保存为草稿</el-button>
        <el-button type="primary" @click="submitContent(1)">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
import BreadCrumb from '../BreadCrumb.vue'
import MyUeditor from '../MyUeditor.vue'
export default {
  name: 'content_add2',
  components: {
    'bread-crumb': BreadCrumb,
    'my-ueditor': MyUeditor
  },
  mounted () {
    this.id = parseInt(this.$route.query.id)
    this.paramStr = this.$route.query.param
    if (this.id > 0) {
      this.title = '内容编辑'
    } else {
      this.title = '内容添加'
    }
    this.getAuthorTypeList()
    this.getCategoryList()
    this.getCharacterList()
    this.getAudioSelectList()
    this.getVideoSelectList()
    if (this.id > 0) {
      this.getInfo(this.id)
    } else {
      this.getAuthorList()
    }
    this.uplodPrepare()
  },
  data () {
    return {
      id: 0,
      paramStr: '',
      mediaFileList: [],
      title: '',
      categoryList: [],
      characterList: [],
      authorList: [],
      mediaOptions: { 1: [], 2: [] },
      mediaLoading: { 1: false, 2: false },
      titleTranslateLoading: false,
      bodyTranslateLoading: false,
      articleFetchLoading: false,
      translationVisible: false,
      articleApiUrl: '',
      mediaSearchSequence: { 1: 0, 2: 0 },
      uploadPrepareResp: {},
      formData: {
        audio_id: 0,
        video_id: 0,
        title: '',
        title_en: '',
        author_en: '',
        title_sub: '',
        category_id: 0,
        character_id: 0,
        author: '',
        author_type: 1,
        pic: '',
        pic_label: '',
        source: '',
        body: '',
        body_en: '',
        publish_start: '',
        status: 1
      },
      picUrl: '',
      formRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        category_id: [
          { required: true, message: '分类不能为空', trigger: 'blur' }
        ],
        publish_start: [
          { required: true, message: '请选择发布时间', trigger: 'change' }
        ],
        body: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      },
      authorTypeList: [],
      authorTypeTitle: '作者'
    }
  },
  methods: {
    closeContentPage () {
      this.$refs.formRef.resetFields()
      this.mediaFileList = []
      this.picUrl = ''
      this.formData.audio_id = 0
      this.formData.video_id = 0
      this.$router.push('/content/list?param=' + this.paramStr)
    },
    submitContent (status) {
      const save = () => {
        // Do not mutate formData: otherwise a second save divides the timestamp again.
        const data = Object.assign({}, this.formData, { status: status })
        data.publish_start = data.publish_start ? Math.floor(data.publish_start / 1000) : 0
        if (this.id === 0) {
          this.addContentPost(data)
        } else {
          this.updateContentPost(data)
        }
      }
      // Drafts may be incomplete; publishing retains the existing form validation.
      if (status === 2) {
        save()
      } else {
        this.$refs.formRef.validate(valid => {
          if (valid) {
            save()
            return
          }
          // 编辑器内容较长时，提交按钮与校验提示可能不在同一视口内。
          this.$nextTick(() => {
            const invalidField = this.$el.querySelector('.el-form-item.is-error')
            if (invalidField) {
              invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        })
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    async getCategoryList () {
      const res = await this.$http.get('/admin/category/select_list')
      if (res.code === 0) {
        this.categoryList = res.data || []
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCharacterList () {
      const res = await this.$http.get('/admin/characteristic_column/select_list')
      if (res.code === 0) {
        this.characterList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAuthorTypeList () {
      const res = await this.$http.get('/admin/author/type_list')
      if (res.code === 0) {
        this.authorTypeList = res.data
      } else {
        this.$message.error(res.msg)
      }
      this.roleId = parseInt(window.sessionStorage.getItem('role_id'))
    },
    authorTypeChange () {
      for (var i = 0; i < this.authorTypeList.length; i++) {
        if (this.authorTypeList[i].id === this.formData.author_type) {
          this.authorTypeTitle = this.authorTypeList[i].title
        }
      }
      this.getAuthorList()
    },
    async getAuthorList () {
      const res = await this.$http.get('/admin/author/select_list', { type: this.formData.author_type })
      if (res.code === 0) {
        this.authorList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    getAudioSelectList (keyword = '') {
      return this.getMediaSelectList(1, keyword)
    },
    getVideoSelectList (keyword = '') {
      return this.getMediaSelectList(2, keyword)
    },
    async getMediaSelectList (type, keyword = '') {
      const sequence = ++this.mediaSearchSequence[type]
      this.mediaLoading[type] = true
      try {
        const res = await this.$http.get('/admin/media/select_list', { keyword, type })
        if (sequence !== this.mediaSearchSequence[type]) return
        if (res.code === 0) {
          const field = type === 1 ? 'audio_id' : 'video_id'
          const selected = this.mediaOptions[type].find(item => item.id === this.formData[field])
          this.mediaOptions[type] = res.data || []
          if (selected && !this.mediaOptions[type].some(item => item.id === selected.id)) {
            this.mediaOptions[type].unshift(selected)
          }
        } else {
          this.$message.error(res.msg)
        }
      } finally {
        if (sequence === this.mediaSearchSequence[type]) this.mediaLoading[type] = false
      }
    },
    async getInfo () {
      const res = await this.$http.get('/admin/content/info/' + this.id)
      if (res.code === 0) {
        this.formData = {
          audio_id: res.data.audio_id || 0,
          video_id: res.data.video_id || 0,
          title: res.data.title,
          title_en: res.data.title_en || '',
          author_en: res.data.author_en || '',
          title_sub: res.data.title_sub,
          category_id: res.data.category_id,
          character_id: res.data.character_id,
          author: res.data.author_id,
          author_type: res.data.author_type || 1,
          pic: res.data.pic,
          pic_label: res.data.pic_label || '',
          source: res.data.source,
          body: res.data.body,
          body_en: res.data.body_en || '',
          publish_start: res.data.publish_start * 1000,
          status: res.data.status || 1
        }
        if (this.formData.publish_start === 0) {
          this.formData.publish_start = ''
        }
        this.picUrl = res.data.pic_url
        await Promise.all([1, 2].map(async type => {
          const field = type === 1 ? 'audio_id' : 'video_id'
          if (!this.formData[field]) return
          const media = await this.$http.get('/admin/media/info/' + this.formData[field])
          if (media.code === 0 && media.data && media.data.type === type && !this.mediaOptions[type].some(item => item.id === media.data.id)) {
            this.mediaOptions[type].unshift(media.data)
          }
        }))
        this.mediaFileList = []
        this.authorTypeChange()
      }
    },
    getBody (content) {
      this.formData.body = content.replace('class="loadingclass"', '')
    },
    getBodyEn (content) {
      this.formData.body_en = content.replace('class="loadingclass"', '')
    },
    async fetchArticleContent () {
      if (!this.articleApiUrl) {
        this.$message.error('请输入文章页面或详情 API 地址')
        return
      }
      this.articleFetchLoading = true
      try {
        const response = await window.fetch(this.getArticleApiUrl())
        if (!response.ok) {
          throw new Error('请求失败')
        }
        const result = await response.json()
        if (result && result.code === 0 && result.data) {
          this.formData.title_en = result.data.title || ''
          this.formData.body_en = result.data.content || ''
          this.formData.author_en = result.data.author || result.data.author_name || result.data.reporter_title || ''
          this.$message.success('英文标题、内容和作者已抓取，请检查后保存')
        } else {
          this.$message.error((result && result.msg) || '未获取到文章标题、内容和作者')
        }
      } catch (error) {
        this.$message.error('文章抓取失败，请检查 API 地址或网络连接')
      } finally {
        this.articleFetchLoading = false
      }
    },
    getArticleApiUrl () {
      const inputUrl = new URL(this.articleApiUrl)
      const articleMatch = inputUrl.pathname.match(/-(\d+)\/?$/)
      if (!articleMatch) {
        return this.articleApiUrl
      }
      return `${inputUrl.protocol}//${inputUrl.host}/api/api/article/detail/${articleMatch[1]}`
    },
    async translateTitle () {
      if (!this.formData.title) {
        this.$message.error('请先填写标题')
        return
      }
      this.titleTranslateLoading = true
      try {
        const res = await this.$http.post('/admin/content/translate_preview', {
          title: this.formData.title,
          translate_field: 'title'
        })
        if (res.code === 0) {
          this.formData.title_en = res.data.title_en || ''
          this.$message.success('标题翻译完成，请检查后保存')
        } else {
          this.$message.error(res.msg)
        }
      } finally {
        this.titleTranslateLoading = false
      }
    },
    async translateBody () {
      if (!this.formData.body) {
        this.$message.error('请先填写内容')
        return
      }
      this.bodyTranslateLoading = true
      try {
        const res = await this.$http.post('/admin/content/translate_preview', {
          body: this.formData.body,
          translate_field: 'body'
        })
        if (res.code === 0) {
          this.formData.body_en = res.data.body_en || ''
          this.$message.success('内容翻译完成，请检查后保存')
        } else {
          this.$message.error(res.msg)
        }
      } finally {
        this.bodyTranslateLoading = false
      }
    },
    formatMediaLabel (item) {
      if (!item) return ''
      const typeLabel = item.type === 1 ? '音频' : (item.type === 2 ? '视频' : '媒体')
      return `[${typeLabel}] ${item.title}`
    },
    async handleMediaSelect (id, type) {
      const field = type === 1 ? 'audio_id' : 'video_id'
      // Remote results can change while Element UI still displays a cached option.
      // Persist the emitted ID, not a lookup in the current search result list.
      this.formData[field] = Number(id) || 0
      if (!id) return

      let item = this.mediaOptions[type] && this.mediaOptions[type].find(media => media.id === id)
      if ((!item || !item.url) && this.$http) {
        try {
          const res = await this.$http.get('/admin/media/info/' + id)
          if (res.code === 0 && res.data) {
            item = res.data
            if (!this.mediaOptions[type].some(media => media.id === item.id)) {
              this.mediaOptions[type].unshift(item)
            }
          }
        } catch (e) {
          // ignore
        }
      }

      if (!item || !item.url) {
        if (this.$message) {
          this.$message.error('媒体不存在或链接不完整')
        }
        return
      }

      const mediaType = this.getMediaType(item, type)
      if (this.$refs && this.$refs.bodyEditor && this.$refs.bodyEditor.insertMedia) {
        this.$refs.bodyEditor.insertMedia(item.url, mediaType)
      }
    },
    getMediaType (item, fallbackType) {
      if (item && item.type === 1) return 'audio'
      if (item && item.type === 2) return 'video'
      if (fallbackType === 1) return 'audio'
      if (fallbackType === 2) return 'video'
      const rawPath = item ? (item.path || item.url || '') : ''
      const path = rawPath.toLowerCase()
      if (path.endsWith('.mp3') || path.endsWith('.ogg') || path.endsWith('.wav') || path.endsWith('.m4a')) {
        return 'audio'
      }
      return 'video'
    },
    handleUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'image/' + this.getDateString() + '/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.pic = res.key
        this.picUrl = this.uploadPrepareResp.res_domain + res.key
      }
      observable.subscribe({ next, error, complete })
      this.uplodPrepare()
      return false
    },
    getDateString () {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },
    handlePicSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    async addContentPost (data) {
      const res = await this.$http.post('/admin/content/add', data)
      if (res.code === 0) {
        this.closeContentPage()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateContentPost (data) {
      const res = await this.$http.post('/admin/content/update/' + this.id, data)
      if (res.code === 0) {
        this.closeContentPage()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
.form_body {
  background-color: #ffffff;
  padding: 20px 20px 30px 0px;
}
.translation_panel {
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  margin: 0 20px 20px 100px;
}
.translation_panel_header {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: space-between;
  line-height: 44px;
}
.translation_panel_body {
  padding-top: 16px;
}
.article-api-input {
  width: 600px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
